(() => {
  if (window.__lunaOdemlyCartSyncInstalled) return;
  window.__lunaOdemlyCartSyncInstalled = true;

  const originalFetch = window.fetch.bind(window);
  const originalXhrOpen = XMLHttpRequest.prototype.open;
  const originalXhrSend = XMLHttpRequest.prototype.send;
  let syncTimer;

  const isCartAdd = (value) => {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      return url.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  };

  const refreshThemeCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await originalFetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) return;
    const cart = await response.json();

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'odemly-cart-sync',
        data: { itemCount: cart.item_count, source: 'odemly-cart-sync' }
      }
    }));
  };

  const scheduleCartRefresh = () => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      refreshThemeCart().catch((error) => console.error('Cart refresh failed', error));
    }, 200);
  };

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const input = args[0];
    const requestUrl = typeof input === 'string' ? input : input?.url || input?.href || '';

    if (response.ok && isCartAdd(requestUrl)) scheduleCartRefresh();
    return response;
  };

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.__lunaCartAddUrl = url;
    return originalXhrOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function(...args) {
    if (isCartAdd(this.__lunaCartAddUrl)) {
      this.addEventListener('loadend', () => {
        if (this.status >= 200 && this.status < 300) scheduleCartRefresh();
      }, { once: true });
    }
    return originalXhrSend.apply(this, args);
  };
})();